module.exports = __webpack_public_path__ + "static/media/ZillaSlab-BoldItalic.289b8d12.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-BoldItalic.ttf
// module id = 3494
// module chunks = 51